import FleetService from "../../services/fleet/service";
import { mapVesselDataFromJson, mapInfoDataFromJson } from "../../domain/fleet/mapper";
import commitVesselsDataToOldStore from "./utils/commit_vessels_data";

const fleetService = new FleetService(
  process.env.VUE_APP_BASIC_URL,
  mapVesselDataFromJson,
  mapInfoDataFromJson
);

const getDefaultState = () => {
  return {
    selectedVessel: null,
    fleet: [],
    fetchFleetLoading: false,
    fetchFleetError: null,
    infoDetails: [],
    //fetchInfoDetailsLoading: false,
    //fetchInfoDetailsError: null,
    isDrawerOpen: false,
    theme: "dark",
    idlePeriods: [],
    idleLoading: false,
    idleError: null,
  };
};

const state = getDefaultState();

const mutations = {
  SET_SELECTED_VESSEL(state, vessel) {
    state.selectedVessel = vessel;
  },
  SET_FLEET(state, fleet) {
    state.fleet = fleet;
  },
  SET_FLEET_LOADING(state, loading) {
    state.fetchFleetError = null;
    state.fetchFleetLoading = loading;
  },
  SET_FLEET_ERROR(state, error) {
    state.fetchFleetError = error;
    state.fetchFleetLoading = false;
  },
  SET_FLEET_SUCCESS(state, data) {
    state.fleet = data;
    state.fetchFleetLoading = false;
    state.fetchFleetError = null;
  },

  SET_INFO_DETAILS(state, infoDetails) {
    state.infoDetails = infoDetails;
  },
  SET_INFO_DETAILS_LOADING(state, loading) {
    state.InfoDetailsError = null;
    state.InfoDetailsLoading = loading;
  },
  SET_INFO_DETAILS_ERROR(state, error) {
    state.InfoDetailsError = error;
    state.InfoDetailsLoading = false;
  },
  SET_INFO_DETAILS_SUCCESS(state, data) {
    state.infoDetails = data;
    state.InfoDetailsLoading = false;
    state.InfoDetailsError = null;
  },
  SET_DRAWER_OPEN(state, open) {
    state.isDrawerOpen = open;
  },
  SET_THEME(state, theme) {
    state.theme = theme;
  },
  SET_IDLE_LOADING(state, loading) {
    state.idleLoading = loading;
    state.idleError = null;
  },

  SET_IDLE_SUCCESS(state, data) {
    state.idlePeriods = data;
    state.idleLoading = false;
    state.idleError = null;
  },

  SET_IDLE_ERROR(state, error) {
    state.idleError = error;
    state.idleLoading = false;
  },

};

const actions = {
  async fetchFleet({ commit }) {
    if (state.fleet.length === 0) {
      commit("SET_FLEET_LOADING", true);
      try {
        const fleet = await fleetService.fetchFleet(localStorage.getItem("quad_token"));
        //TODO: Eventually remove this (check function commitVesselsDataToOldStore).
        commitVesselsDataToOldStore(fleet, commit);

        commit("SET_FLEET_SUCCESS", fleet);
        return fleet;

      } catch (error) {

        commit("SET_FLEET_ERROR", error);
      } finally {
        commit("SET_FLEET_LOADING", false);
      }
    }
  },
  async fetchIdlePeriods({ commit }, payload) {
    commit("SET_IDLE_LOADING", true);

    try {
      const result = await fleetService.fetchVesselIdlePeriods(
        localStorage.getItem("quad_token"),
        payload
      );

      commit("SET_IDLE_SUCCESS", result);
      return result;

    } catch (error) {

      commit("SET_IDLE_ERROR", error);
    }
  },

  toggleDrawer({ commit }) {
    commit("SET_DRAWER_OPEN", !state.isDrawerOpen);
  }
};

const getters = {
  minCoordinates: (state) => {
    return state.fleet.reduce((min, vessel) => {
      return {
        lat: Math.min(min.lat, vessel.coordinates[0]),
        lng: Math.min(min.lng, vessel.coordinates[1]),
      };
    }, { lat: 90, lng: 180 });
  },
  maxCoordinates: (state) => {
    return state.fleet.reduce((max, vessel) => {
      return {
        lat: Math.max(max.lat, vessel.coordinates[0]),
        lng: Math.max(max.lng, vessel.coordinates[1]),
      };
    }, { lat: -90, lng: -180 });
  },
  flyToCoordinates: (_, getters) => {

    return [
      (getters.minCoordinates.lat + getters.maxCoordinates.lat) / 2,
      (getters.minCoordinates.lng + getters.maxCoordinates.lng) / 2
    ];
  },
  getIdlePeriods: (state) => state.idlePeriods,
  getIdleLoading: (state) => state.idleLoading,
  getIdleError: (state) => state.idleError,

};

export const mainModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

/*
    async fetchInfoDetails({ commit }) {
        if (state.infoDetails.length === 0) {
            commit('SET_INFO_DETAILS_LOADING', true);
            try {
                const infoDetails = await fleetService.fetchInfoDetails(localStorage.getItem('quad_token'));

                commit('SET_INFO_DETAILS_SUCCESS', infoDetails);
                return infoDetails;

            } catch (error) {
                commit('SET_INFO_DETAILS_ERROR', error);
            } finally {
                commit('SET_INFO_DETAILS_LOADING', false);
            }
        }
    },*/
